import template from './schedule-k-summary-report.html';
import controller from './schedule-k-summary-report.controller';

let scheduleKSummaryReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default scheduleKSummaryReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/schedule-k-summary-report/schedule-k-summary-report.component.js